import React from "react";

function Investments() {
	return <h1>Investments content</h1>;
}

export default Investments;
